import { request } from "./http";

/** Upload une image base64 sur le serveur et retourne son URL publique. */
export const uploadImage = (base64: string): Promise<string> =>
  request<{ ok: boolean; fileName: string; url: string }>("/uploads", {
    method: "POST",
    body:   JSON.stringify({ base64 }),
  }).then(r => r.url);
